export default __webpack_public_path__ + "static/portfolio-26-f3dcf17af83ece988bcbe6f6b60bcca3.jpg";